import * as React from 'react'
import styled from 'styled-components'
import media from '../../../services/generateMediaQueries'

const Desktop = styled.div`
  display: none;
  ${media.greaterThan('small')`
    display: block;
  `}
`

const Mobile = styled.div`
  ${media.greaterThan('small')`
    display: none;
  `}
`

const DesktopSideModal = styled.div`
  display: none;
  ${media.greaterThan('modal')`
    display: block;
  `}
`

const MobileSideModal = styled.div`
  ${media.greaterThan('modal')`
    display: none;
  `}
`
const ResponsiveAdsContainer = ({ desktop, mobile, sideModal }) => {
  // TODO: define template, behaviors etc.
  if (sideModal) {
    return (
      <div>
        <DesktopSideModal>{desktop}</DesktopSideModal>
        <MobileSideModal>{mobile}</MobileSideModal>
      </div>
    )
  }
  return (
    <div>
      <Desktop>{desktop}</Desktop>
      <Mobile>{mobile}</Mobile>
    </div>
  )
}

ResponsiveAdsContainer.defaultProps = {
  // TODO: specify default props
}

ResponsiveAdsContainer.propTypes = {
  // TODO: specify prop types
}

export default ResponsiveAdsContainer
